import { dateFormats, DateObject } from '@capsicum/common';
import { atom, useAtom } from 'jotai';

import { useTimerAcceptedAtom } from './useTimerAcceptedAtom';

/**
 * If `startedDate` is provided, `customExpirationPeriod` is not allowed.
 *
 * If `customExpirationPeriod` is provided, `startedDate` is not allowed.
 */
type SetExpirationsPeriodAndDateProps =
	| {
			customExpirationPeriod?: never;
			expirationDate: string;
			startedDate?: string;
	  }
	| {
			customExpirationPeriod?: number;
			expirationDate: string;
			startedDate?: never;
	  };

const timerExpireDateAtom = atom<null | string>('');
const processStartedAtAtom = atom<string>('');

export const DEFAULT_EXPIRATION_PERIOD = 900000; // 15 minutes
const configExpirationPeriodAtom = atom<number>(DEFAULT_EXPIRATION_PERIOD);

export const useTimerExpiredDateAtom = () => {
	const [timerExpireDate, setTimerExpireDate] = useAtom(timerExpireDateAtom);
	const [processStartedAt, setProcessStartedAt] = useAtom(processStartedAtAtom);
	const [configExpirationPeriod, setConfigExpirationPeriod] = useAtom(configExpirationPeriodAtom);
	const { setTimerExpiredAccepted, timerExpiredAccepted } = useTimerAcceptedAtom();
	const { isValidDate } = dateFormats;

	const setTimerExpire = (processExpiresAt: null | string) => {
		setTimerExpireDate(processExpiresAt);
		//TODO PFFT KEEP FOR TESTING PURPOSES
		//setTimerExpireDate(dateFormats.add(1, 'minute').toISOString());

		setTimerExpiredAccepted(processExpiresAt ? true : false);
	};

	const setExpirationsPeriodAndDate = ({
		customExpirationPeriod,
		expirationDate,
		startedDate
	}: SetExpirationsPeriodAndDateProps) => {
		const expireDate = new DateObject(expirationDate);
		const now = new DateObject();
		const isExpirationDateValid = isValidDate(expirationDate || '');
		const expirationPeriod = isExpirationDateValid
			? expireDate.diff(startedDate || now, 'milliseconds')
			: DEFAULT_EXPIRATION_PERIOD;

		setTimerExpire(isExpirationDateValid ? expirationDate : null);

		setConfigExpirationPeriod(customExpirationPeriod || expirationPeriod);
	};

	return {
		configExpirationPeriod,
		processStartedAt,
		setConfigExpirationPeriod,
		setExpirationsPeriodAndDate,
		setProcessStartedAt,
		setTimerExpire,
		setTimerExpireDate,
		timerExpiredAccepted,
		timerExpireDate
	};
};
